export default __webpack_public_path__ + "static/media/GothamBookItalic.ad21531a.otf";